/* global BRAND */

import React from 'react'
import { LazyLoadingProvider as LoadingProvider } from 'loankeeper-common/components/hocs/LazyLoading'

import BrandedComponentLoader from 'shared/BrandedComponentLoader'

// eslint-disable-next-line import/no-dynamic-require
const theme = require(`../../../brands/${BRAND}/theme.json`)

export const Loader = () => <BrandedComponentLoader component="GlobalLoading.js" />

const LazyLoadingProvider = (props) => (
  <LoadingProvider {...props} loader={Loader} backgroundColor={theme.loadingOverlayBackgroundColor} />
)

export default LazyLoadingProvider
